import Swiper, {EffectFade} from "swiper";

Swiper.use([EffectFade])
export function initTournamentSlider(){

    let swiper = new Swiper('#tournament_slider', {
        loop: false,
        speed: 700,
        preloadImages: false,
        slidesPerView: 1,
        spaceBetween: 0,
        noSwiping: true,
        allowTouchMove: false,
        autoHeight: true,
        watchOverflow: true,
        resizeObserver: true,
        wrapperHeight: 'auto',
        breakpoints: {
            0: {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0
            },
            500: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        }
    });

    return swiper;
}